<div class="main-container d-flex text-center align-items-center justify-content-center coming-soon">
  <div class="coming-soon-content">
    <h1 class="display-4">
      <b>{{ title }}</b>
    </h1>
    <h2>
      Permission Required
    </h2>
    <ng-template ngxPermissionsOnly="Admin">
      <div>Only available in Django Admin</div>
      <div>
        Url:
        <a [href]="adminUrl" target="_blank">
          {{ adminUrl }}
        </a>
      </div>
    </ng-template>
  </div>
</div>
